<dx-popup [title]="'fileTransfers.lblRunTransfer' | translate" [height]="500" [(visible)]="visible" (onShown)="onShown()" (onHidden)="onHidden()">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view id="scrollview">
            <div class="form">
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.selection</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>logs.lblEnvironment</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="currentEnvironment?.environmentName"></dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>logs.lblTransfer</div>
                        <div class="dx-field-value">
                            <dx-select-box #ftSelectBox
                                           acceptCustomValue="false"
                                           displayExpr="name"
                                           searchEnabled="true"
                                           valueExpr="id"
                                           [dataSource]="fileTransfers"
                                           [noDataText]="'_pickers.nodata' | translate"
                                           [placeholder]="'_pickers.placeholder' | translate"
                                           (onSelectionChanged)="onTransferChanged($event)">
                                <dx-validator>
                                    <dxi-validation-rule *ngIf="isRequired" type="required" [message]="'_pickers.msgFileTransferRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-select-box>
                        </div>
                    </div>
                </div>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.execution</div>
                    <div class="center">
                        <dx-button [disabled]="!this.selectedFileTransferId || this.isTransferInProgress"
                                   [text]="'_commons.execute' | translate"
                                   (onClick)="executeFileTransfer()"></dx-button>
                    </div>
                    <br />
                    <div class="center" *ngIf="isTransferInProgress">
                        <dx-progress-bar #progressBar
                                         id="progress-bar-status"
                                         max="3"
                                         min="0"
                                         width="100%"
                                         [height]="15"
                                         [showStatus]="false"
                                         [value]="transferStep" />
                        <span>{{ transferProgression }}</span>
                    </div>
                </div>
            </div>
        </dx-scroll-view>
        <div class="flex bottom-buttons">
            <dx-button class="close closeButton" [text]="'_commons.close' | translate" (onClick)="this.visible = false"></dx-button>
        </div>
    </div>
</dx-popup>

<!-- Display popup -->
<app-local-agent-command #agentCommandPopup></app-local-agent-command>